export function lastUtcDays(days = 7, now = new Date()) {
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  return {
    from: new Date(today - (days - 1) * 86_400_000).toISOString().slice(0, 10),
    to: new Date(today).toISOString().slice(0, 10),
  }
}

function utcDay(now: Date, offsetDays = 0) {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + offsetDays))
}

/** Monday of the ISO week containing `date`. */
function startOfIsoWeek(date: Date) {
  const day = date.getUTCDay() || 7
  return utcDay(date, 1 - day)
}

const iso = (d: Date) => d.toISOString().slice(0, 10)

export const DATE_PRESETS = [
  "this_week",
  "last_week",
  "this_month",
  "last_month",
  "last_30_days",
] as const
export type DatePreset = (typeof DATE_PRESETS)[number]

export const DATE_PRESET_LABELS: Record<DatePreset, string> = {
  this_week: "This week",
  last_week: "Last week",
  this_month: "This month",
  last_month: "Last month",
  last_30_days: "Last 30 days",
}

/** UTC calendar ranges, the same zone the report's day buckets use — a preset
 *  picks the same days whether the server or the browser is ahead. */
export function datePreset(preset: DatePreset, now = new Date()): { from: string; to: string } {
  switch (preset) {
    case "this_week": {
      const start = startOfIsoWeek(utcDay(now))
      return { from: iso(start), to: iso(utcDay(start, 6)) }
    }
    case "last_week": {
      const start = startOfIsoWeek(utcDay(now, -7))
      return { from: iso(start), to: iso(utcDay(start, 6)) }
    }
    case "this_month": {
      const start = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)
      const end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0)
      return { from: iso(new Date(start)), to: iso(new Date(end)) }
    }
    case "last_month": {
      const start = Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1)
      const end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0)
      return { from: iso(new Date(start)), to: iso(new Date(end)) }
    }
    case "last_30_days":
      return lastUtcDays(30, now)
  }
}
